(function () {
  function initNcCartFooter() {
    document.querySelectorAll('[data-nc-cart-footer]').forEach(function (footer) {
      if (footer.dataset.ncFooterReady === 'true') return;

      footer.dataset.ncFooterReady = 'true';

      var checkoutButton = footer.querySelector('#bt_checkout_cart');
      var cartForm = document.getElementById('form_cart');

      if (!checkoutButton || !cartForm) return;

      cartForm.addEventListener('submit', function () {
        checkoutButton.classList.add('is-loading');
        checkoutButton.setAttribute('aria-busy', 'true');
      });

      window.addEventListener('pageshow', function () {
        checkoutButton.classList.remove('is-loading');
        checkoutButton.removeAttribute('aria-busy');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNcCartFooter);
  } else {
    initNcCartFooter();
  }

  document.addEventListener('shopify:section:load', initNcCartFooter);
})();